import React from 'react';
import classNames from 'classnames';
import { func, number, bool } from 'prop-types';

import './style.scss';

const SliderNav = ({
  onNext,
  onPrevious,
  setIndex,
  maxBullets,
  selectedPage,
  selectedBullet,
  pageNumber,
  infinityLoop,
}) => {
  const canGoNext = () => {
    return infinityLoop || selectedPage < pageNumber - 1;
  };

  const canGoPrevious = () => {
    return infinityLoop || selectedPage > 0;
  };

  const handleBulletClick = (index) => {
    setIndex(index);
  };

  const handleNextClick = () => {
    if (canGoNext()) {
      onNext();
    }
  };

  const handlePreviousClick = () => {
    if (canGoPrevious()) {
      onPrevious();
    }
  };

  let bullets = [];
  const bulletNumber = pageNumber > maxBullets ? maxBullets : pageNumber;

  for (let index = 0; index < bulletNumber; index++) {
    bullets.push({
      index: selectedPage + (index - selectedBullet),
      selected: index === selectedBullet,
    });
  }

  return (
    <div className="slider-nav">
      <button
        type="button"
        className={classNames('slider-nav__arrow slider-nav__arrow--prev', {
          'slider-nav__arrow--disabled': !canGoPrevious(),
        })}
        onClick={handlePreviousClick}
        aria-label="previous button"
      />
      <div className="slider-nav__bullets">
        {bullets[0].index > 0 && (
          <button
            className={classNames('slider-nav__bullet', 'slider-nav__bullet--small', {
              'slider-nav__bullet--active': selectedBullet < 0,
            })}
            onClick={() => handleBulletClick(bullets[0].index - 1, -1)}
          />
        )}
        {bullets.map((bullet, key) => {
          return (
            <button
              key={key}
              className={classNames('slider-nav__bullet', { 'slider-nav__bullet--active': bullet.selected })}
              onClick={() => handleBulletClick(bullet.index, key)}
            />
          );
        })}
        {bullets[bullets.length - 1].index < pageNumber - 1 && (
          <button
            className={classNames('slider-nav__bullet', 'slider-nav__bullet--small', {
              'slider-nav__bullet--active': selectedBullet > maxBullets - 1,
            })}
            onClick={() => handleBulletClick(bullets[bullets.length - 1].index + 1, maxBullets)}
          />
        )}
      </div>
      <button
        type="button"
        className={classNames('slider-nav__arrow slider-nav__arrow--next', {
          'slider-nav__arrow--disabled': !canGoNext(),
        })}
        onClick={handleNextClick}
        aria-label="next button"
      />
    </div>
  );
};

SliderNav.prototype = {
  onNext: func.isRequired,
  onPrevious: func.isRequired,
  setIndex: func.isRequired,
  maxBullets: number.isRequired,
  selectedPage: number.isRequired,
  selectedBullet: number.isRequired,
  pageNumber: number.isRequired,
  infinityLoop: bool.isRequired,
};

export default SliderNav;
